import React from 'react'

import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'
import { useRouteMatch } from 'react-router'

import AnalyticsPostCampaignReportGlossary from '@components/Analytics/PostCampaignReport/Glossary'
import { Hr } from '@components/UI/Hr/Hr.styled'
import Loading from '@components/UI/Loading'
import { NoticeUnsupportedScreen } from '@components/UI/Notice'
import { SupportedScreenWrapper } from '@components/UI/ScreenSize'
import { IApplicationState } from '@store'
import {
  selectIsSummaryActive,
  selectShowCampaignMetricsLoadingScreen,
  selectShowGlossaryButton,
  selectShowSubmissionList,
} from '@store/postCampaignReport'
import { selectCampaignId } from '@store/router'
import Theme from '@theme'
import { Container } from '@tribegroup'
import PostCampaignReportChannelList from './Channel/List/List'
import PostCampaignReportPerformanceListWrapper from './Performance/List/Wrapper/Wrapper'
import PostCampaignReportPerformanceTitle from './Performance/Title/Title'
import { PostCampaignReportProxySubmissionEducationText } from './ProxySubmissionEducation/Text'
import PostCampaignReportSubmissionListWrapper from './Submission/List/Wrapper/Wrapper'
import PostCampaignReportTitle from './Title/Title'

const ScreenLayoutWrapper: React.FC<React.PropsWithChildren> = ({ children }) => (
  <>
    <NoticeUnsupportedScreen
      alt="influencer-view-unsupported-screen"
      title={<FormattedMessage id="postCampaignReport.unsupportedScreen.title" />}
      subtitle={<FormattedMessage id="postCampaignReport.unsupportedScreen.subtitle" />}
    />
    <SupportedScreenWrapper>{children}</SupportedScreenWrapper>
  </>
)

const PostCampaignReport: React.FC = () => {
  const match = useRouteMatch()
  const campaignId = selectCampaignId(match)!
  const showPerformanceTitle = useSelector((state: IApplicationState) =>
    selectIsSummaryActive(state),
  )
  const showLoadingScreen = useSelector((state: IApplicationState) =>
    selectShowCampaignMetricsLoadingScreen(state, campaignId),
  )
  const showSubmissionList = useSelector((state: IApplicationState) =>
    selectShowSubmissionList(state),
  )
  const showGlossaryButton = useSelector((state: IApplicationState) =>
    selectShowGlossaryButton(state),
  )

  if (showLoadingScreen) {
    return <Loading />
  }

  return (
    <ScreenLayoutWrapper>
      <PostCampaignReportTitle />
      <Container topInnerSpacing={2.5}>
        <PostCampaignReportChannelList />
      </Container>
      <Container topInnerSpacing={1.25} bottomInnerSpacing={0.5}>
        <Hr backgroundColor={Theme.primaryColor} />
      </Container>
      {showPerformanceTitle && <PostCampaignReportPerformanceTitle />}
      <Container topOuterSpacing={2}>
        <PostCampaignReportPerformanceListWrapper />
      </Container>
      <PostCampaignReportProxySubmissionEducationText topOuterSpacing={0.375} />
      {showSubmissionList && <PostCampaignReportSubmissionListWrapper />}
      {showGlossaryButton && <AnalyticsPostCampaignReportGlossary />}
    </ScreenLayoutWrapper>
  )
}

export { PostCampaignReport }
export default PostCampaignReport
